import { render } from "./DocumentationView.vue?vue&type=template&id=1dd3e6f6&scoped=true"
const script = {}

import "./DocumentationView.vue?vue&type=style&index=0&id=1dd3e6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd3e6f6"]])

export default __exports__